import { actionTypeDoctor } from "../types";
import { ApiService } from "../../config";
import { Commons } from "../../utilities";
// import { setCache, getCache } from "./actionCache";

export const getDashBoardByDoctorId =
  (DoctorGuid, ClinicGuid) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_REQUEST });
    try {
      const queryParams = Commons.addQueryParameter({ DoctorGuid, ClinicGuid });
      const response = await ApiService.get(
        `/doctor/getDashBoardByDoctorId?${queryParams}`
      );
      const responsePayload = {
        data: response.data,
        status: response.status,
      };
      dispatch({
        type: actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_FAILURE,
        payload: errorPayload,
      });
    }
  };

// export const getDashBoardByDoctorId =
//   (DoctorGuid, ClinicGuid) => async (dispatch, getState) => {
//     const state = getState();
//     const cacheKey = `dashboard_${DoctorGuid}_${ClinicGuid}`;
//     const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//     if (cachedData) {
//       dispatch({
//         type: actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_SUCCESS,
//         payload: cachedData,
//       });
//       return;
//     }

//     dispatch({ type: actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_REQUEST });
//     try {
//       const queryParams = Commons.addQueryParameter({ DoctorGuid, ClinicGuid });
//       const response = await ApiService.get(
//         `/doctor/getDashBoardByDoctorId?${queryParams}`
//       );
//       const responsePayload = {
//         data: response.data,
//         status: response.status,
//       };

//       // Cache the response
//       dispatch(setCache(cacheKey, responsePayload));
//       dispatch({
//         type: actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_SUCCESS,
//         payload: responsePayload,
//       });
//     } catch (error) {
//       const errorPayload = {
//         status: error.response?.status,
//         data: error.response?.data,
//       };
//       dispatch({
//         type: actionTypeDoctor.GET_DASHBOARD_BY_DOCTOR_ID_FAILURE,
//         payload: errorPayload,
//       });
//     }
//   };

export const saveProfileInfo = (credentials, callback) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.POST_SAVE_PROFILE_INFO_REQUEST });

  try {
    const response = await ApiService.post(
      "/doctor/saveprofileinfo",
      JSON.stringify(credentials)
    );

    dispatch({
      type: actionTypeDoctor.POST_SAVE_PROFILE_INFO_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_SAVE_PROFILE_INFO_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
};

export const getProfileInfo = (userGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_PROFILE_INFO_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/getprofileinfo?userGuid=${userGuid}`
    );
    const responsePayload = {
      data: response.data,
      status: response.status,
    };
    dispatch({
      type: actionTypeDoctor.GET_PROFILE_INFO_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_PROFILE_INFO_FAILURE,
      payload: errorPayload,
    });
  }
};

// export const getProfileInfo = (userGuid) => async (dispatch, getState) => {
//   const state = getState();
//   const cacheKey = `profileInfo_${userGuid}`;
//   const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//   if (cachedData) {
//     dispatch({
//       type: actionTypeDoctor.GET_PROFILE_INFO_SUCCESS,
//       payload: cachedData,
//     });
//     return;
//   }

//   dispatch({ type: actionTypeDoctor.GET_PROFILE_INFO_REQUEST });
//   try {
//     const response = await ApiService.get(
//       `/doctor/getprofileinfo?userGuid=${userGuid}`
//     );
//     const responsePayload = {
//       data: response.data,
//       status: response.status,
//     };

//     // Cache the response
//     dispatch(setCache(cacheKey, responsePayload));
//     dispatch({
//       type: actionTypeDoctor.GET_PROFILE_INFO_SUCCESS,
//       payload: responsePayload,
//     });
//   } catch (error) {
//     const errorPayload = {
//       status: error.response?.status,
//       data: error.response?.data,
//     };
//     dispatch({
//       type: actionTypeDoctor.GET_PROFILE_INFO_FAILURE,
//       payload: errorPayload,
//     });
//   }
// };

export const saveAdditionalInfo =
  (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.POST_SAVE_ADDITIONAL_INFO_REQUEST });
    try {
      const response = await ApiService.post(
        "/doctor/saveadditionalinfo",
        JSON.stringify(credentials)
      );

      dispatch({
        type: actionTypeDoctor.POST_SAVE_ADDITIONAL_INFO_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_SAVE_ADDITIONAL_INFO_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getAdditionalInfo = (userGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_ADDITIONAL_INFO_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/getadditionalinfo?userGuid=${userGuid}`
    );
    const responsePayload = {
      data: response.data,
      status: response.status,
    };
    dispatch({
      type: actionTypeDoctor.GET_ADDITIONAL_INFO_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_ADDITIONAL_INFO_FAILURE,
      payload: errorPayload,
    });
  }
};

// export const getAdditionalInfo = (userGuid) => async (dispatch, getState) => {
//   const state = getState();
//   const cacheKey = `additionalInfo_${userGuid}`;
//   const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//   if (cachedData) {
//     dispatch({
//       type: actionTypeDoctor.GET_ADDITIONAL_INFO_SUCCESS,
//       payload: cachedData,
//     });
//     return;
//   }

//   dispatch({ type: actionTypeDoctor.GET_ADDITIONAL_INFO_REQUEST });
//   try {
//     const response = await ApiService.get(
//       `/doctor/getadditionalinfo?userGuid=${userGuid}`
//     );
//     const responsePayload = {
//       data: response.data,
//       status: response.status,
//     };

//     // Cache the response
//     dispatch(setCache(cacheKey, responsePayload));
//     dispatch({
//       type: actionTypeDoctor.GET_ADDITIONAL_INFO_SUCCESS,
//       payload: responsePayload,
//     });
//   } catch (error) {
//     const errorPayload = {
//       status: error.response?.status,
//       data: error.response?.data,
//     };
//     dispatch({
//       type: actionTypeDoctor.GET_ADDITIONAL_INFO_FAILURE,
//       payload: errorPayload,
//     });
//   }
// };

export const addProfileCertificates =
  (formData, fileType, doctorGuid, callback) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.POST_PROFILE_CERTIFICATES_REQUEST });
    try {
      const response = await ApiService.post(
        `/doctor/profilecertificates?fileType=${fileType}&doctorGuid=${doctorGuid}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      dispatch({
        type: actionTypeDoctor.POST_PROFILE_CERTIFICATES_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_PROFILE_CERTIFICATES_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getClinicDoctorDetails = (ClinicGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/getClinicDoctorDetails?ClinicGuid=${ClinicGuid}`
    );
    const responsePayload = {
      data: response.data,
      status: response.status,
    };
    dispatch({
      type: actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_FAILURE,
      payload: errorPayload,
    });
  }
};

// export const getClinicDoctorDetails =
//   (ClinicGuid) => async (dispatch, getState) => {
//     const state = getState();
//     const cacheKey = `clinicDoctorDetails_${ClinicGuid}`;
//     const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//     if (cachedData) {
//       dispatch({
//         type: actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_SUCCESS,
//         payload: cachedData,
//       });
//       return;
//     }

//     dispatch({ type: actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_REQUEST });
//     try {
//       const response = await ApiService.get(
//         `/doctor/getClinicDoctorDetails?ClinicGuid=${ClinicGuid}`
//       );
//       const responsePayload = {
//         data: response.data,
//         status: response.status,
//       };

//       // Cache the response
//       dispatch(setCache(cacheKey, responsePayload));
//       dispatch({
//         type: actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_SUCCESS,
//         payload: responsePayload,
//       });
//     } catch (error) {
//       const errorPayload = {
//         status: error.response?.status,
//         data: error.response?.data,
//       };
//       dispatch({
//         type: actionTypeDoctor.GET_CLINIC_DOCTOR_DETAILS_FAILURE,
//         payload: errorPayload,
//       });
//     }
//   };

export const saveFees = (credentials, callback) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.POST_SAVE_FEES_REQUEST });
  try {
    const response = await ApiService.post(
      "/doctor/savefees",
      JSON.stringify(credentials)
    );
    dispatch({
      type: actionTypeDoctor.POST_SAVE_FEES_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_SAVE_FEES_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
};

export const getFees = (userGuid, clinicGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_FEES_REQUEST });
  try {
    const queryParams = Commons.addQueryParameter({ userGuid, clinicGuid });
    const response = await ApiService.get(`/doctor/getfees?${queryParams}`);
    const responsePayload = {
      data: response.data,
      status: response.status,
    };
    dispatch({
      type: actionTypeDoctor.GET_FEES_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_FEES_FAILURE,
      payload: errorPayload,
    });
  }
};

// export const getFees = (userGuid, clinicGuid) => async (dispatch, getState) => {
//   const state = getState();
//   const cacheKey = `fees_${userGuid}_${clinicGuid}`;
//   const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//   if (cachedData) {
//     dispatch({
//       type: actionTypeDoctor.GET_FEES_SUCCESS,
//       payload: cachedData,
//     });
//     return;
//   }

//   dispatch({ type: actionTypeDoctor.GET_FEES_REQUEST });
//   try {
//     const queryParams = Commons.addQueryParameter({ userGuid, clinicGuid });
//     const response = await ApiService.get(`/doctor/getfees?${queryParams}`);
//     const responsePayload = {
//       data: response.data,
//       status: response.status,
//     };

//     // Cache the response
//     dispatch(setCache(cacheKey, responsePayload));
//     dispatch({
//       type: actionTypeDoctor.GET_FEES_SUCCESS,
//       payload: responsePayload,
//     });
//   } catch (error) {
//     const errorPayload = {
//       status: error.response?.status,
//       data: error.response?.data,
//     };
//     dispatch({
//       type: actionTypeDoctor.GET_FEES_FAILURE,
//       payload: errorPayload,
//     });
//   }
// };

export const getAllAdditionalServices =
  (doctorGuid, doctorCurrency) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_REQUEST });
    try {
      const queryParams = Commons.addQueryParameter({
        doctorGuid,
        doctorCurrency,
      });
      const response = await ApiService.get(
        `/doctor/alladditionalservice?${queryParams}`
      );
      const responsePayload = {
        data: response.data,
        status: response.status,
      };
      dispatch({
        type: actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_FAILURE,
        payload: errorPayload,
      });
    }
  };

// export const getAllAdditionalServices =
//   (doctorGuid, doctorCurrency) => async (dispatch, getState) => {
//     const state = getState();
//     const cacheKey = `allAdditionalServices_${doctorGuid}_${doctorCurrency}`;
//     const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//     if (cachedData) {
//       dispatch({
//         type: actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_SUCCESS,
//         payload: cachedData,
//       });
//       return;
//     }

//     dispatch({ type: actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_REQUEST });
//     try {
//       const queryParams = Commons.addQueryParameter({
//         doctorGuid,
//         doctorCurrency,
//       });
//       const response = await ApiService.get(
//         `/doctor/alladditionalservice?${queryParams}`
//       );
//       const responsePayload = {
//         data: response.data,
//         status: response.status,
//       };

//       // Cache the response
//       dispatch(setCache(cacheKey, responsePayload));
//       dispatch({
//         type: actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_SUCCESS,
//         payload: responsePayload,
//       });
//     } catch (error) {
//       const errorPayload = {
//         status: error.response?.status,
//         data: error.response?.data,
//       };
//       dispatch({
//         type: actionTypeDoctor.GET_ALL_ADDITIONAL_SERVICES_FAILURE,
//         payload: errorPayload,
//       });
//     }
//   };

export const saveAdditionalServiceInfo =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_SAVE_ADDITIONAL_SERVICE_INFO_REQUEST,
    });
    try {
      const response = await ApiService.post(
        "/doctor/saveadditionalserviceinfo",
        JSON.stringify(credentials)
      );
      dispatch({
        type: actionTypeDoctor.POST_SAVE_ADDITIONAL_SERVICE_INFO_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_SAVE_ADDITIONAL_SERVICE_INFO_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const deleteServiceById =
  (ServiceGuid, callback) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.DELETE_SERVICE_BY_ID_REQUEST });
    try {
      const response = await ApiService.delete(
        `/doctor/deleteservicebyid?ServiceGuid=${ServiceGuid}`
      );
      dispatch({
        type: actionTypeDoctor.DELETE_SERVICE_BY_ID_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.DELETE_SERVICE_BY_ID_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const saveDefaultTiming =
  (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.POST_SAVE_DEFAULTTIMING_REQUEST });
    try {
      const response = await ApiService.post(
        "/doctor/savedefaulttiming",
        JSON.stringify(credentials)
      );
      dispatch({
        type: actionTypeDoctor.POST_SAVE_DEFAULTTIMING_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_SAVE_DEFAULTTIMING_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getDefaultTiming =
  (doctorGuid, clinicGuid, isClinicSchedule) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.GET_DEFAULT_TIMING_REQUEST });
    try {
      const queryParams = Commons.addQueryParameter({
        doctorGuid,
        clinicGuid,
        isClinicSchedule,
      });


      const response = await ApiService.get(
        `/doctor/getdefaulttiming?${queryParams}`
      );
      const responsePayload = {
        data: response.data,
        status: response.status,
      };
      dispatch({
        type: actionTypeDoctor.GET_DEFAULT_TIMING_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_DEFAULT_TIMING_FAILURE,
        payload: errorPayload,
      });
    }
  };

// export const getDefaultTiming =
//   (doctorGuid, isClinicSchedule) => async (dispatch, getState) => {
//     const state = getState();
//     const cacheKey = `defaultTiming_${doctorGuid}_${isClinicSchedule}`;
//     const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//     if (cachedData) {
//       dispatch({
//         type: actionTypeDoctor.GET_DEFAULT_TIMING_SUCCESS,
//         payload: cachedData,
//       });
//       return;
//     }

//     dispatch({ type: actionTypeDoctor.GET_DEFAULT_TIMING_REQUEST });
//     try {
//       const queryParams = Commons.addQueryParameter({
//         doctorGuid,
//         isClinicSchedule,
//       });
//       const response = await ApiService.get(
//         `/doctor/getdefaulttiming?${queryParams}`
//       );
//       const responsePayload = {
//         data: response.data,
//         status: response.status,
//       };

//       // Cache the response
//       dispatch(setCache(cacheKey, responsePayload));
//       dispatch({
//         type: actionTypeDoctor.GET_DEFAULT_TIMING_SUCCESS,
//         payload: responsePayload,
//       });
//     } catch (error) {
//       const errorPayload = {
//         status: error.response?.status,
//         data: error.response?.data,
//       };
//       dispatch({
//         type: actionTypeDoctor.GET_DEFAULT_TIMING_FAILURE,
//         payload: errorPayload,
//       });
//     }
//   };

export const deleteDefaultTimingById =
  (defaultGuid, callback) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.DELETE_DEFAULT_TIMING_BY_ID_REQUEST });
    try {
      const response = await ApiService.delete(
        `/doctor/deletedefaulttimingbyid?defaultGuid=${defaultGuid}`
      );
      dispatch({
        type: actionTypeDoctor.DELETE_DEFAULT_TIMING_BY_ID_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.DELETE_DEFAULT_TIMING_BY_ID_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const saveCustomTiming = (credentials, callback) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.POST_SAVE_CUSTOM_TIMING_REQUEST });
  try {
    const response = await ApiService.post(
      "/doctor/savecustomtiming",
      JSON.stringify(credentials)
    );
    dispatch({
      type: actionTypeDoctor.POST_SAVE_CUSTOM_TIMING_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_SAVE_CUSTOM_TIMING_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
};

export const getCustomTiming =
  (doctorGuid, clinicGuid, IsClinicSchedule) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.GET_CUSTOM_TIMING_REQUEST });
    try {
      const response = await ApiService.get(
        `/doctor/getcustomtiming?doctorGuid=${doctorGuid}&clinicGuid=${clinicGuid}&IsClinicSchedule=${IsClinicSchedule}`
      );

      const responsePayload = {
        data: response.data,
        status: response.status,
      };
      dispatch({
        type: actionTypeDoctor.GET_CUSTOM_TIMING_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_CUSTOM_TIMING_FAILURE,
        payload: errorPayload,
      });
    }
  };

// export const getCustomTiming = (doctorGuid) => async (dispatch, getState) => {
//   const state = getState();
//   const cacheKey = `customTiming_${doctorGuid}`;
//   const cachedData = getCache(state, cacheKey, 300000); // 5-minute cache duration

//   if (cachedData) {
//     dispatch({
//       type: actionTypeDoctor.GET_CUSTOM_TIMING_SUCCESS,
//       payload: cachedData,
//     });
//     return;
//   }

//   dispatch({ type: actionTypeDoctor.GET_CUSTOM_TIMING_REQUEST });
//   try {
//     const response = await ApiService.get(
//       `/doctor/getcustomtiming?doctorGuid=${doctorGuid}`
//     );
//     const responsePayload = {
//       data: response.data,
//       status: response.status,
//     };

//     // Cache the response
//     dispatch(setCache(cacheKey, responsePayload));
//     dispatch({
//       type: actionTypeDoctor.GET_CUSTOM_TIMING_SUCCESS,
//       payload: responsePayload,
//     });
//   } catch (error) {
//     const errorPayload = {
//       status: error.response?.status,
//       data: error.response?.data,
//     };
//     dispatch({
//       type: actionTypeDoctor.GET_CUSTOM_TIMING_FAILURE,
//       payload: errorPayload,
//     });
//   }
// };

export const deleteCustomTimingById =
  (defaultGuid, callback) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.DELETE_CUSTOM_TIMING_BY_ID_REQUEST });
    try {
      const response = await ApiService.delete(
        `/doctor/deletecustomtimingbyid?defaultGuid=${defaultGuid}`
      );
      dispatch({
        type: actionTypeDoctor.DELETE_CUSTOM_TIMING_BY_ID_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.DELETE_CUSTOM_TIMING_BY_ID_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getClinicDetailsByDoctorId = (doctorGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_CLINIC_DETAILS_BY_DOCTOR_ID_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/getClinicDetailsByDoctorId?doctorGuid=${doctorGuid}`
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };
    dispatch({
      type: actionTypeDoctor.GET_CLINIC_DETAILS_BY_DOCTOR_ID_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_CLINIC_DETAILS_BY_DOCTOR_ID_FAILURE,
      payload: errorPayload,
    });
  }
};

export const getClinicDoctorServiceAndSchedule =
  (DoctorGuid, ClinicGuid, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({ DoctorGuid, ClinicGuid });
      const response = await ApiService.get(
        `/doctor/getClinicDoctorServiceAndSchedule?${queryParams}`
      );
      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_FAILURE,
        payload: errorPayload,
      });
      if (callback) {
        callback(error.response);
      }
    }
  };

export const clearClinicDoctorServiceAndScheduleData = () => ({
  type: actionTypeDoctor.CLEAR_CLINIC_DOCTOR_SERVICE_AND_SCHEDULE_DATA,
});

export const getAllClinicRequests = (clinicGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_ALL_CLINIC_REQUESTS_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/getallclinicrequests?clinicGuid=${clinicGuid}`
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.GET_ALL_CLINIC_REQUESTS_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_ALL_CLINIC_REQUESTS_FAILURE,
      payload: errorPayload,
    });
  }
};

export const postSendDoctorClinicRequest =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_SEND_DOCTOR_CLINIC_REQUEST_REQUEST,
    });

    try {
      const response = await ApiService.post(
        "/doctor/senddoctorclinicrequest",
        JSON.stringify(credentials)
      );

      dispatch({
        type: actionTypeDoctor.POST_SEND_DOCTOR_CLINIC_REQUEST_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_SEND_DOCTOR_CLINIC_REQUEST_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getAllDoctorClinicRequests = (doctorGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_ALL_DOCTOR_CLINIC_REQUESTS_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/getalldoctorclinicrequests?doctorGuid=${doctorGuid}`
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.GET_ALL_DOCTOR_CLINIC_REQUESTS_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_ALL_DOCTOR_CLINIC_REQUESTS_FAILURE,
      payload: errorPayload,
    });
  }
};

export const postDoctorsPatient =
  (pageSize, currentPage, search, patientGuid, doctorGuid) =>
    async (dispatch) => {
      dispatch({ type: actionTypeDoctor.POST_DOCTORS_PATIENT_REQUEST });
      try {
        // pageSize, currentPage, search, sortExp, sortDir, patientGuid, doctorGuid
        const queryParams = Commons.addQueryParameter({
          pageSize,
          currentPage,
          search,
          patientGuid,
          doctorGuid,
        });

        const response = await ApiService.post(
          `/doctor/doctorspatient?${queryParams}`
        );

        const responsePayload = {
          data: response.data,
          status: response.status,
        };

        dispatch({
          type: actionTypeDoctor.POST_DOCTORS_PATIENT_SUCCESS,
          payload: responsePayload,
        });
      } catch (error) {
        const errorPayload = {
          status: error.response?.status,
          data: error.response?.data,
        };

        dispatch({
          type: actionTypeDoctor.POST_DOCTORS_PATIENT_FAILURE,
          payload: errorPayload,
        });
      }
    };

export const postFinanceData = (credentials) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.POST_FINANCE_DATA_REQUEST });

  try {
    const response = await ApiService.post(
      "/doctor/financedata",
      JSON.stringify(credentials)
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.POST_FINANCE_DATA_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.POST_FINANCE_DATA_FAILURE,
      payload: errorPayload,
    });
  }
};

export const getClinicDoctor = (DoctorGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_CLINIC_DOCTOR_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/getClinicDoctor?DoctorGuid=${DoctorGuid}`
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.GET_CLINIC_DOCTOR_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_CLINIC_DOCTOR_FAILURE,
      payload: errorPayload,
    });
  }
};

export const getChatAppointmentByDoctor = (credentials) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_CHAT_APPOINTMENT_BY_DOCTOR_REQUEST });
  try {
    const response = await ApiService.post(
      "doctor/getChatAppointmentByDoctor",
      JSON.stringify(credentials)
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.GET_CHAT_APPOINTMENT_BY_DOCTOR_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.POST_FINANCE_DATA_FAILURE,
      payload: errorPayload,
    });
  }
};

export const getEmergencyCallByDoctor = (credentials) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_EMERGENCY_CALL_BY_DOCTOR_REQUEST });
  try {
    const response = await ApiService.post(
      "doctor/getEmergencyCallByDoctor",
      JSON.stringify(credentials)
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.GET_EMERGENCY_CALL_BY_DOCTOR_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_EMERGENCY_CALL_BY_DOCTOR_FAILURE,
      payload: errorPayload,
    });
  }
};

export const postCreateClinicDoctorServices =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.CREATE_CLINIC_DOCTOR_SERVICES_REQUEST,
    });
    try {
      const response = await ApiService.post(
        "/doctor/createClinicDoctorServices",
        JSON.stringify(credentials)
      );
      dispatch({
        type: actionTypeDoctor.CREATE_CLINIC_DOCTOR_SERVICES_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.CREATE_CLINIC_DOCTOR_SERVICES_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const postCreateClinicDoctorAdditionalServices =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_REQUEST,
    });

    try {
      const response = await ApiService.post(
        "/doctor/createClinicDoctorAdditionalServices",
        JSON.stringify(credentials)
      );
      dispatch({
        type: actionTypeDoctor.CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.CREATE_CLINIC_DOCTOR_ADDITIONAL_SERVICES_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const postSaveFaq = (credentials, callback) => async (dispatch) => {
  dispatch({
    type: actionTypeDoctor.POST_SAVE_FAQ_REQUEST,
  });

  try {
    const response = await ApiService.post(
      "/doctor/savefaq",
      JSON.stringify(credentials)
    );
    dispatch({
      type: actionTypeDoctor.POST_SAVE_FAQ_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_SAVE_FAQ_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
};

export const getFAQ = (doctorGuid, search) => async (dispatch) => {
  dispatch({
    type: actionTypeDoctor.GET_FAQ_REQUEST,
  });
  try {
    const queryParams = Commons.addQueryParameter({
      doctorGuid,
      search,
    });

    const response = await ApiService.get(`/doctor/getfaq?${queryParams}`);

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.GET_FAQ_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_FAQ_FAILURE,
      payload: errorPayload,
    });
  }
};

export const deleteFaq = (faqGuid, callback) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.DELETE_FAQ_REQUEST });
  try {
    const response = await ApiService.delete(
      `/doctor/deletefaq?faqGuid=${faqGuid}`
    );
    dispatch({
      type: actionTypeDoctor.DELETE_FAQ_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.DELETE_FAQ_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
};

export const getAllInvoiceDoctorById =
  (clinicGuid, doctorGuid) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_ALL_INVOICE_DOCTOR_BY_ID_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        clinicGuid,
        doctorGuid,
      });

      const response = await ApiService.get(
        `/doctor/getAllInvoiceDoctorById?${queryParams}`
      );

      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_ALL_INVOICE_DOCTOR_BY_ID_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_ALL_INVOICE_DOCTOR_BY_ID_FAILURE,
        payload: errorPayload,
      });
    }
  };

export const getDiagnosticById =
  (appointmentGuid, requestCurrency) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_DIAGNOSTIC_BY_ID_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        appointmentGuid,
        requestCurrency,
      });

      const response = await ApiService.get(
        `/api/getdiagnosticbyid?${queryParams}`
      );

      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_DIAGNOSTIC_BY_ID_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_DIAGNOSTIC_BY_ID_FAILURE,
        payload: errorPayload,
      });
    }
  };

export const getAllAppointmentDetail =
  (appointmentGuid, exchangeCurrency, isChatAnonymous) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        appointmentGuid,
        exchangeCurrency,
        isChatAnonymous,
      });

      const response = await ApiService.get(
        `/api/getallappointmentdetail?${queryParams}`
      );

      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_FAILURE,
        payload: errorPayload,
      });
    }
  };

export const postAdditionalServices =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_ADDITIONAL_SERVICES_REQUEST,
    });

    try {
      const response = await ApiService.post(
        "/doctor/additionalservices",
        JSON.stringify(credentials)
      );

      dispatch({
        type: actionTypeDoctor.POST_ADDITIONAL_SERVICES_SUCCESS,
        payload: response,
      });

      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_ADDITIONAL_SERVICES_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getAdditionalServiceInfo =
  (appointmentGuid, exchangeCurrency) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_ADDITIONAL_SERVICE_INFO_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        appointmentGuid,
        exchangeCurrency,
      });

      const response = await ApiService.get(
        `/doctor/getadditionalserviceinfo?${queryParams}`
      );

      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_ADDITIONAL_SERVICE_INFO_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };

      dispatch({
        type: actionTypeDoctor.GET_ADDITIONAL_SERVICE_INFO_FAILURE,
        payload: errorPayload,
      });
    }
  };

export const postDiagnosticReport =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_DIAGNOSTIC_REPORT_REQUEST,
    });

    try {
      const response = await ApiService.post(
        "/doctor/diagnosticreport",
        JSON.stringify(credentials)
      );

      dispatch({
        type: actionTypeDoctor.POST_DIAGNOSTIC_REPORT_SUCCESS,
        payload: response,
      });

      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_DIAGNOSTIC_REPORT_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getAllAppointmentDetailList =
  (appointmentGuid, exchangeCurrency, isChatAnonymous) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_LIST_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        appointmentGuid,
        exchangeCurrency,
        isChatAnonymous,
      });
      const response = await ApiService.get(
        `/api/getallappointmentdetaillist?${queryParams}`
      );

      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_LIST_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };

      dispatch({
        type: actionTypeDoctor.GET_ALL_APPOINTMENT_DETAIL_LIST_FAILURE,
        payload: errorPayload,
      });
    }
  };

export const deleteClinicAdditionalService =
  (ClinicDoctorAdditionalServicesGuid, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_REQUEST,
    });
    try {
      const response = await ApiService.delete(
        `/doctor/deleteClinicDoctorAdditionalService?ClinicDoctorAdditionalServicesGuid=${ClinicDoctorAdditionalServicesGuid}`
      );
      dispatch({
        type: actionTypeDoctor.DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.DELETE_CLINIC_DOCTOR_ADDITIONAL_SERVICE_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const postSaveInvoiceSetting =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_SAVE_INVOICE_SETTING_REQUEST,
    });

    try {
      const response = await ApiService.post(
        "/doctor/saveInvoiceSetting",
        JSON.stringify(credentials)
      );

      dispatch({
        type: actionTypeDoctor.POST_SAVE_INVOICE_SETTING_SUCCESS,
        payload: response,
      });

      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_SAVE_INVOICE_SETTING_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getInvoiceSettingByGuid =
  (doctorGuid, clinicGuid) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_INVOICE_SETTING_BY_GUID_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        doctorGuid,
        clinicGuid,
      });

      const response = await ApiService.get(
        `/doctor/getInvoiceSettingByGuid?${queryParams}`
      );

      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_INVOICE_SETTING_BY_GUID_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };
      dispatch({
        type: actionTypeDoctor.GET_INVOICE_SETTING_BY_GUID_FAILURE,
        payload: errorPayload,
      });
    }
  };

export const getInvoice =
  (appointmentGuid, isForDoctor, doctorCurrency) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.GET_INVOICE_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        appointmentGuid,
        isForDoctor,
        doctorCurrency,
      });

      const response = await ApiService.get(`/doctor/invoice?${queryParams}`);

      const responsePayload = {
        data: response.data,
        status: response.status,
      };

      dispatch({
        type: actionTypeDoctor.GET_INVOICE_SUCCESS,
        payload: responsePayload,
      });
    } catch (error) {
      const errorPayload = {
        status: error.response?.status,
        data: error.response?.data,
      };

      dispatch({
        type: actionTypeDoctor.GET_INVOICE_FAILURE,
        payload: errorPayload,
      });
    }
  };

export const postSaveInvoiceList = (credentials) => async (dispatch) => {
  dispatch({
    type: actionTypeDoctor.POST_SAVE_INVOICE_LIST_REQUEST,
  });

  try {
    const response = await ApiService.post(
      "/doctor/saveInvoiceList",
      JSON.stringify(credentials)
    );
    dispatch({
      type: actionTypeDoctor.POST_SAVE_INVOICE_LIST_SUCCESS,
      payload: response,
    });
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_SAVE_INVOICE_LIST_FAILURE,
      payload: error,
    });
  }
};

export const postMarkAppointmentAsComplete =
  (appointmentGuid, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_MARK_APPOINTMENT_AS_COMPLETE_REQUEST,
    });
    try {
      const queryParams = Commons.addQueryParameter({
        appointmentGuid,
      });

      const response = await ApiService.post(
        `/doctor/markappointmentascomplete?${queryParams}`
      );

      dispatch({
        type: actionTypeDoctor.POST_MARK_APPOINTMENT_AS_COMPLETE_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_MARK_APPOINTMENT_AS_COMPLETE_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const postUpdateDoctorFeesCurrency =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_UPDATE_DOCTOR_FEES_CURRENCY_REQUEST,
    });

    try {
      const response = await ApiService.post(
        "/doctor/updateDoctorFeesCurrency",
        JSON.stringify(credentials)
      );

      dispatch({
        type: actionTypeDoctor.POST_UPDATE_DOCTOR_FEES_CURRENCY_SUCCESS,
        payload: response,
      });

      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_UPDATE_DOCTOR_FEES_CURRENCY_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const getMassMessages = (userGuid) => async (dispatch) => {
  dispatch({
    type: actionTypeDoctor.GET_MASS_MESSAGES_REQUEST,
  });
  try {
    const response = await ApiService.get(
      `/doctor/getMassMessages?userGuid=${userGuid}`
    );

    const responsePayload = {
      data: response.data,
      status: response.status,
    };

    dispatch({
      type: actionTypeDoctor.GET_MASS_MESSAGES_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };

    dispatch({
      type: actionTypeDoctor.GET_MASS_MESSAGES_FAILURE,
      payload: errorPayload,
    });
  }
};

export const postCreateMassMessage =
  (credentials, callback) => async (dispatch) => {
    dispatch({
      type: actionTypeDoctor.POST_CREATE_MASS_MESSAGE_REQUEST,
    });
    try {
      const response = await ApiService.post(
        "/doctor/createMassMessage",
        JSON.stringify(credentials)
      );

      dispatch({
        type: actionTypeDoctor.POST_CREATE_MASS_MESSAGE_SUCCESS,
        payload: response,
      });

      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_CREATE_MASS_MESSAGE_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const postUpdateEmergencyCall =
  (credentials, callback) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.POST_UPDATE_EMERGENCY_CALL_REQUEST });
    try {
      const response = await ApiService.post(
        "/doctor/updateEmergencyCall",
        JSON.stringify(credentials)
      );
      dispatch({
        type: actionTypeDoctor.POST_UPDATE_EMERGENCY_CALL_SUCCESS,
        payload: response,
      });
      if (callback) {
        callback(null, response);
      }
    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_UPDATE_EMERGENCY_CALL_FAILURE,
        payload: error,
      });
      if (callback) {
        callback(error.response, null);
      }
    }
  };

export const postBookedEmergencyAppointment =
  (credentials) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.POST_BOOKED_EMERGENCY_APPOINTMENT_REQUEST });
    try {
      const response = await ApiService.post(
        "doctor/bookedEmergencyAppointment",
        JSON.stringify(credentials)
      );
      dispatch({
        type: actionTypeDoctor.POST_BOOKED_EMERGENCY_APPOINTMENT_SUCCESS,
        payload: response,
      });

    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_BOOKED_EMERGENCY_APPOINTMENT_FAILURE,
        payload: error,
      });

    }
  };

export const postGetChatHistory =
  (credentials) => async (dispatch) => {
    dispatch({ type: actionTypeDoctor.POST_GET_CHAT_HISTORY_REQUESTT });
    try {
      const response = await ApiService.post(
        "doctor/getChatHistory",
        JSON.stringify(credentials)
      );
      dispatch({
        type: actionTypeDoctor.POST_GET_CHAT_HISTORY_SUCCESSS,
        payload: response,
      });

    } catch (error) {
      dispatch({
        type: actionTypeDoctor.POST_GET_CHAT_HISTORY_FAILUREE,
        payload: error,
      });

    }
  };

export const getListPatientDetailsByDoctor = (doctorGuid) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_LIST_PATIENT_DETAILS_BY_DOCTOR_REQUEST });
  try {
    const response = await ApiService.get(
      `/doctor/listPatientDetailsByDoctor?doctorGuid=${doctorGuid}`
    );
    const responsePayload = {
      data: response.data,
      status: response.status,
    };
    dispatch({
      type: actionTypeDoctor.GET_LIST_PATIENT_DETAILS_BY_DOCTOR_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_LIST_PATIENT_DETAILS_BY_DOCTOR_FAILURE,
      payload: errorPayload,
    });
  }
};

export const postUpdateChatAppointment = (credentials, callback) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.POST_UPDATE_CHAT_APPOINTMENT_REQUEST });

  try {
    const response = await ApiService.post(
      "/doctor/updateChatAppointment",
      JSON.stringify(credentials)
    );
    dispatch({
      type: actionTypeDoctor.POST_UPDATE_CHAT_APPOINTMENT_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_UPDATE_CHAT_APPOINTMENT_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
}

export const postUpdateChatNotification = (credentials, callback) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.POST_UPDATE_CHAT_NOTIFICATION_REQUEST });

  try {
    const response = await ApiService.post(
      "/doctor/updateChatNotification",
      JSON.stringify(credentials)
    );
    dispatch({
      type: actionTypeDoctor.POST_UPDATE_CHAT_NOTIFICATION_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_UPDATE_CHAT_NOTIFICATION_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
}

export const postUpdatePdf = (credentials, callback) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.POST_UPDATE_PDF_REQUEST });
  try {
    const response = await ApiService.post(
      "/doctor/UpdatePdf",
      JSON.stringify(credentials)
    );
    dispatch({
      type: actionTypeDoctor.POST_UPDATE_PDF_SUCCESS,
      payload: response,
    });
    if (callback) {
      callback(null, response);
    }
  } catch (error) {
    dispatch({
      type: actionTypeDoctor.POST_UPDATE_PDF_FAILURE,
      payload: error,
    });
    if (callback) {
      callback(error.response, null);
    }
  }
}


export const getChatNotification = (userGuid, currency, userType) => async (dispatch) => {
  dispatch({ type: actionTypeDoctor.GET_CHAT_NOTIFICATION_REQUEST });
  try {
    const queryParams = Commons.addQueryParameter({
      userGuid,
      currency,
      userType,
    });
    const response = await ApiService.get(
      `/doctor/getChatNotification?${queryParams}`
    );
    const responsePayload = {
      data: response.data,
      status: response.status,
    };
    dispatch({
      type: actionTypeDoctor.GET_CHAT_NOTIFICATION_SUCCESS,
      payload: responsePayload,
    });
  } catch (error) {
    const errorPayload = {
      status: error.response?.status,
      data: error.response?.data,
    };
    dispatch({
      type: actionTypeDoctor.GET_CHAT_NOTIFICATION_FAILURE,
      payload: errorPayload,
    });
  }
};


const actionDoctor = {
  getDashBoardByDoctorId,
  saveProfileInfo,
  getProfileInfo,
  saveAdditionalInfo,
  getAdditionalInfo,
  addProfileCertificates,
  getClinicDoctorDetails,
  saveFees,
  getFees,
  getAllAdditionalServices,
  saveAdditionalServiceInfo,
  deleteServiceById,
  saveDefaultTiming,
  getDefaultTiming,
  deleteDefaultTimingById,
  saveCustomTiming,
  getCustomTiming,
  deleteCustomTimingById,
  getClinicDetailsByDoctorId,
  getClinicDoctorServiceAndSchedule,
  clearClinicDoctorServiceAndScheduleData,
  getAllClinicRequests,
  postSendDoctorClinicRequest,
  getAllDoctorClinicRequests,
  postDoctorsPatient,
  postFinanceData,
  getClinicDoctor,
  getChatAppointmentByDoctor,
  getEmergencyCallByDoctor,
  postCreateClinicDoctorServices,
  postCreateClinicDoctorAdditionalServices,
  postSaveFaq,
  getFAQ,
  deleteFaq,
  getAllInvoiceDoctorById,
  getDiagnosticById,
  getAllAppointmentDetail,
  postAdditionalServices,
  getAdditionalServiceInfo,
  postDiagnosticReport,
  getAllAppointmentDetailList,
  deleteClinicAdditionalService,
  postSaveInvoiceSetting,
  getInvoiceSettingByGuid,
  getInvoice,
  postSaveInvoiceList,
  postMarkAppointmentAsComplete,
  postUpdateDoctorFeesCurrency,
  getMassMessages,
  postCreateMassMessage,
  postUpdateEmergencyCall,
  postBookedEmergencyAppointment,
  postGetChatHistory,
  getListPatientDetailsByDoctor,
  postUpdateChatAppointment,
  postUpdateChatNotification,
  postUpdatePdf,
  getChatNotification,
};

export default actionDoctor;
